export class MessageContextInfoUser {
  public usermame: string;
  public password: string;
  public ipRequest: string;
  constructor() { }
}